import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import { OtpVerificationType, StudentRegistrationType } from "../Utils/Enums";
import SessionManager from '../Utils/Session';
import dayjs from "dayjs";


const CoordinatorApiServices = {
    coordinatorlogin: async (email, password) => {
        try {
            const response = await axios.post(ApiConstants.coordinatorlogin, {
                email: email.trim(),
                password: password.trim(),

            });

            if (response.status === 200) {
                const token = response.data.token;
                SessionManager.shared.setCoordinatorSessionToken(token);
                return response.data;

            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    verifyOTP: async (email, otp, type) => {
        try {
            const response = await axios.post(ApiConstants.coordinatorverifyOtp, { email: email.trim(), otp: otp.trim(), type: type.trim() });

            if (response.status === 200) {
                const token = response.data.token;
                type == OtpVerificationType.forgotPassword ?
                    SessionManager.shared.setForgotPasswordToken(token) :
                    SessionManager.shared.setCoordinatorSessionToken(token);
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    coforgotPassword: async (email) => {
        try {
            const response = await axios.post(ApiConstants.coforgotPassword, {
                email: email.trim(),
            });

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    coresetPassword: async (newPassword) => {
        try {
            const response = await axios.post(
                ApiConstants.coresetPassword,
                { newPassword: newPassword.trim() },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getForgotPasswordToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    getCoordinatorDetails: async () => {
        try {
            const response = await axios.get(ApiConstants.getCoordinatorDetails,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getCoordinatorToken()}`,
                    },
                });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error
        }
    },


    cochangePassword: async (currentPassword, newPassword, confirmPassword) => {
        try {
            const response = await axios.post(ApiConstants.cochangePassword, { currentPassword: currentPassword.trim(), newPassword: newPassword.trim(), confirmPassword: confirmPassword.trim() }, {
                headers: {
                    Authorization: `Bearer ${SessionManager.shared.getCoordinatorToken()}`,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    updateProfilePic: async (file) => {
        const formData = new FormData();
        formData.append("profile_pic", file)
        try {
            const response = await axios.put(ApiConstants.updateProfileDetails, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${SessionManager.shared.getCoordinatorToken()}`,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },



    getAllPurchaseList: async (offset, limit, startDate, endDate,) => {
        try {
            // Construct the query string with the provided dates
            const queryParams = new URLSearchParams({
                offset: offset,
                limit: limit,
            });

            // Append startDate and endDate if they are provided
            if (startDate) {
                queryParams.append('startDate', dayjs(startDate).format('YYYY-MM-DD'));
            } else {
                queryParams.append('startDate', "");
            }
            if (endDate) {
                queryParams.append('endDate', dayjs(endDate).format('YYYY-MM-DD'));
            } else if (startDate && !endDate) {
                queryParams.append('endDate', dayjs(new Date()).format('YYYY-MM-DD'));
            } else {
                queryParams.append('endDate', "");
            }

            // Construct the full URL
            const url = `${ApiConstants.getAllPurchaseList}?${queryParams.toString()}`;

            const response = await axios.get(url,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getCoordinatorToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    getwithdrawReq: async (offset, limit) => {
        try {
            const response = await axios.get(ApiConstants.getwithdrawReq +
                `?offset=${offset}&limit=${limit}`,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getCoordinatorToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    coupdateProfileDetails: async (file) => {
        const formData = new FormData();
        formData.append("profilePicture", file)
        try {
            const response = await axios.post(ApiConstants.coupdateProfileDetails, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${SessionManager.shared.getCoordinatorToken()}`,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },


    addBankDetails: async (
        accountholdername,
        accountnumber,
        accounttype,
        branch,
        uploadDocuments,
        confirmaccountnumber,
        ifsccode,
        pannumber,
    ) => {
        try {
            const formData = new FormData();
            formData.append("accountHolderName", accountholdername);
            formData.append("accountNumber", accountnumber);
            formData.append("accountType", accounttype);
            formData.append("branch", branch);
            formData.append("cancelledChequeImage", uploadDocuments);
            formData.append("confirmaccountnumber", confirmaccountnumber);
            formData.append("ifscCode", ifsccode);
            formData.append("panNumber", pannumber);

            const response = await axios.post(ApiConstants.addBankDetails, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${SessionManager.shared.getCoordinatorToken()}`,
                },
            });

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            // Handle API errors here
            throw error;
        }
    },
    invoice: async (
        order_id,

    ) => {
        try {
            const response = await axios.get(`${ApiConstants.invoice}/${order_id}`,
                {
                    headers: {
                        'Content-Type': 'application/pdf',
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                    responseType: 'blob',
                }
            );

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            // Handle API errors here
            throw error;
        }
    },
    getwithdrawlamount: async (coordinator_id, amount, status) => {
        try {
            const response = await axios.post(
                ApiConstants.getwithdrawlamount,
                {
                    coordinator_id: coordinator_id,
                    amount: amount,

                    status: status
                },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getCoordinatorToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    gettransactionhistory: async (offset, limit) => {
        try {
            const response = await axios.get(ApiConstants.gettransactionhistory +
                `?offset=${offset}&limit=${limit}`,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getCoordinatorToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

}
export default CoordinatorApiServices